import { Avatar, Dropdown, Flex, MenuProps } from 'antd'
import { useGetUser } from '../api/user/user.ts'
import { useDarkMode } from '../hooks/useDarkMode.tsx'
import { getHSLColor } from '../utils/color.ts'
import { LogoutOutlined, MoonOutlined, SettingOutlined, SunOutlined } from "@ant-design/icons"

export const UserControlComponent = () => {
    const { data: userInfo } = useGetUser()
    const { darkModeEnabled, switchDarkMode } = useDarkMode()

    const items: MenuProps['items'] = [
        {
            key: 'user',
            type: 'group',
            label: userInfo?.email,
            children: [
                {
                    key: 'settings',
                    label: <Flex justify="space-between">Account Settings <SettingOutlined/></Flex>,
                    onClick: () => {
                        if (userInfo?.accountSettingsUrl) {
                            window.location.href = userInfo.accountSettingsUrl
                        }
                    }
                },
                {
                    key: 'switch-dark-mode',
                    label: darkModeEnabled ?
                        <Flex justify="space-between">Enable Light Mode <SunOutlined/></Flex> :
                        <Flex justify="space-between">Enable Dark Mode <MoonOutlined/></Flex>,
                    onClick: () => {
                        switchDarkMode()
                    }
                },
                {
                    key: 'login',
                    label: <Flex justify="space-between">Logout <LogoutOutlined/></Flex>,
                    onClick: () => {
                        if (userInfo) {
                            window.location.href =
                                userInfo.logoutUrl + '?redirect_to=' + window.location.href
                        }
                    }
                }
            ],
        }
    ]

    const menuProps = {
        items
    }

    const avatarColor = getHSLColor(userInfo?.email || '')
    const avatarTitle = userInfo?.email && userInfo.email[0].toUpperCase()

    return (
        <Dropdown
            menu={menuProps}
            overlayStyle={{ height: '32px' }}
            trigger={['click']}
        >
            <Avatar style={{
                cursor: 'pointer',
                backgroundColor: avatarColor
            }}>
                {avatarTitle}
            </Avatar>
        </Dropdown>
    )
}
